import { IProductType } from './product-type.type';
import { RecordNumber } from './record-number.type';
import { RecordString } from './record-string.type';
import { IRegistrationType } from './registration-type';
import { ISales } from './sales.type';

export type ISalesDetailsPayment = RecordNumber<'amount' | 'sequenceNumber'> & {
  paidDate: string;
  dueDate: string;
  state: ISalesDetailsPaymentState;
};

export type ISalesDetailsRegistration = RecordString<
  'student' | 'partnership' | 'status' | 'schoolLevel' | 'duration'
> & {
  id: number;
  productType: IProductType;
  registrationType: IRegistrationType;
};

export type ISalesDetails = ISales &
  RecordString<'schoolYear' | 'email' | 'deliveryCountry'> & {
    payments: ISalesDetailsPayment[];
    registrations: ISalesDetailsRegistration[];
  };

export enum ISalesDetailsPaymentState {
  authorized = 'authorized',
  cart = 'cart',
  new = 'new',
  processing = 'processing',
  completed = 'completed',
  failed = 'failed',
  cancelled = 'cancelled',
  refunded = 'refunded',
  unknown = 'unknown',
}
